module.exports = __webpack_public_path__ + "media/soundtrack.3041a03a.mp3";